angular.module('dealerware.web.data').factory('DealerwareDriversLicenseModel', function ($http,Model,$q, $dealerwareInternationalizationDateFormats) {
    var parseDateForRequest = function (date) {
        var parsedDate = $dealerwareInternationalizationDateFormats.parseDateForRequest(date, 'YYYY-MM-DD');
        return parsedDate;
    };

    var parseDateForResponse = function (date) {
        var lastFormats = ['YYYY-MM-DD', 'MM-DD-YYYY'];
        var parsedDate = $dealerwareInternationalizationDateFormats.parseDateToDisplayOnTheApplication(date, lastFormats);
        return date !== null && date !== undefined ? parsedDate : '';
    };

    var model = new Model({
        baseEndpoint: '/locations/:location_id/customers/:customer_id/drivers_license',
        actionOverrides: {
            create: {
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            },
            update: {
                endpoint: '/locations/:location_id/customers/:customer_id/drivers_license',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            }
        },
        customActions: {
            get: {
                method: 'GET',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            }
        },
        requestTransforms: new function() {
            this._always = function(args, data) {
                delete data.can_rent;
                delete data.expired;
                data.expiration     = parseDateForRequest(data.expiration);
                data.date_of_birth  = parseDateForRequest(data.date_of_birth);
                data.verified = true;

                delete data.id;
            };

            this.update = function(args, data) {
                this._always(args, data);
            };

            this.create = function(args, data) {
                this._always(args, data);
            };
        },
        responseTransforms: new function() {
            this.index = function(args, data) {
                data.date_of_birth  = parseDateForResponse(data.date_of_birth);
                data.expiration     = parseDateForResponse(data.expiration);
            };

            this.get = function(args, data) {
                data.date_of_birth  = parseDateForResponse(data.date_of_birth);
                data.expiration     = parseDateForResponse(data.expiration);
            };
        }
    });

    jQuery.extend(model.prototype,{
        isComplete: function() {
            var isComplete = true;

            if ( this.data && isObject(this.data) ){
                if ( this.data.hasOwnProperty('number') && this.data.hasOwnProperty('state') && this.data.hasOwnProperty('line1') && this.data.hasOwnProperty('city') && this.data.hasOwnProperty('zip') && this.data.hasOwnProperty('expiration') && this.data.hasOwnProperty('date_of_birth') ) {
                    if ( !( this.data.number && this.data.state && this.data.line1 && this.data.city && this.data.zip && this.data.expiration && this.data.date_of_birth ) ) {
                        isComplete = false;
                    }
                }
                else {
                    isComplete =false;
                }
            }
            else {
                isComplete = false;
            }
            return isComplete;
        },
        toSummaryString: function() {
            var sum = '';
            if (this.data && isObject(this.data) ) {
                if (this.data.hasOwnProperty('number')) {
                    sum = this.data.number;
                }
                if (this.data.hasOwnProperty('state') && this.data.state) {
                    sum += " " + this.data.state.toUpperCase();
                }
            }
            return sum;

        },
        isRequired: function() {
            return !this.isComplete();
        },
        isUnchanged: function(){
            var unchanged = true;

            if ( this.data.country != this.master.country ){
                unchanged = false;
            }
            else if ( this.data.number != this.master.number ){
                unchanged = false;
            }
            else if ( this.data.name != this.master.name ){
                unchanged = false;
            }
            else if (this.data.line1 != this.master.line1 ){
                unchanged = false;
            }
            else if (this.data.line2 != this.master.line2 ){
                unchanged = false;
            }
            else if (this.data.city != this.master.city ){
                unchanged = false;
            }
            else if (this.data.state != this.master.state ){
                unchanged = false;
            }
            else if (this.data.zip != this.master.zip ){
                unchanged = false;
            }
            else if (this.data.verified != this.master.verified){
                unchanged = false;
            }
            else if (!this.expirationIsUnchanged(this.data.expiration,this.master.expiration)){
                unchanged = false;
            } else if (!this.dobIsUnchanged(this.data.date_of_birth,this.master.date_of_birth)){
                unchanged = false;
            }
            return unchanged;
        },
        expirationIsUnchanged: function(expiration,expiration_master){
            var expiration_string;
            if (expiration && expiration_master && !angular.isString(expiration) ){
                var curr_date = expiration.getDate() +"";
                var curr_month = expiration.getMonth() + 1 + "";
                var curr_year = expiration.getFullYear();
                curr_date = curr_date.replace(/^(\d)$/, '0$1');
                curr_month = curr_month.replace(/^(\d)$/, '0$1');
                expiration_string = curr_year + "-" + curr_month + "-" + curr_date;
            }
            else {
                expiration_string = expiration;
            }
            return (expiration_string == expiration_master);
        },
        dobIsUnchanged: function(dob,dob_master) {
            var dob_string;
            if ( dob && dob_master && !angular.isString(dob)){
                var curr_date = dob.getDate() +"";
                var curr_month = dob.getMonth() + 1 + "";
                var curr_year = dob.getFullYear();
                curr_date = curr_date.replace(/^(\d)$/, '0$1');
                curr_month = curr_month.replace(/^(\d)$/, '0$1');
                dob_string = curr_year + "-" + curr_month + "-" + curr_date;
            }
            else {
                dob_string = dob;
            }
            return (dob_string == dob_master);
        },
        dlInfoChange: function(){
            if (!this.isUnchanged()){
                this.data.verified = false;
            }
        }
    });

    return model;
})
.config(function($provide) {
    $provide.decorator('DriversLicenseModel', function($delegate,$injector) {
        return $injector.get("DealerwareDriversLicenseModel");
    });
});
